/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const greenApiWebhookInteractiveButtonsResponseSchema = z.object({
	stanzaId: z.string(),
	selectedButtonId: z.string(),
});
